import { render, staticRenderFns } from "./IdentityVerifyPreviewModal.vue?vue&type=template&id=5c1d01a3&scoped=true&"
import script from "./IdentityVerifyPreviewModal.vue?vue&type=script&lang=js&"
export * from "./IdentityVerifyPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./IdentityVerifyPreviewModal.vue?vue&type=style&index=0&id=5c1d01a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d01a3",
  null
  
)

export default component.exports